import FBody from '@/plugins/form/FBody';
import api from '@/plugins/api';

import component from './component.vue';

import Info from './Info';
import Price from './Price';
import Program from './Program';
import Term from './Term';
import Dates from './Dates';
import Tourist from './Tourist';
import Tariffs from './Tariffs';
import AdditionalService from "./AdditionalService";
import Hotel from "./Hotel";
import SeatingArrangements from './SeatingArrangements';

import core from '@/core';

export default class TourClientItem extends FBody {
  component = component;

  id = '';

  comment = '';

  info = new Info(this);

  price = new Price(this);

  program = new Program(this);

  term = new Term(this);

  dates = new Dates(this);

  tourist = new Tourist(this);

  tariffs = new Tariffs(this);

  additionalService = new AdditionalService(this);

  hotel = new Hotel(this);

  seat = new SeatingArrangements(this);

  constructor(props) {
    super(props);
    this.setItems([
      ['tourist', this.tourist],
    ]);
  }


  get data() {
    return {
      TourId: this.id,
      Price: this.price.allPrice,
      Tourists: this.tourist.data,
      IsPreorder: this.tourist.type !== 'pay',
      Comment: this.comment,
      AdditionalServices: this.additionalService.data,
      SeatingArrangementInfo: this.seat.data,
    };
  }

  submit() {
    this.loading = true
    const isCorrect = this.seat.checkCountTourists();

    if (!isCorrect) {
      this.loading = false;
      core.notify.error('Ошибка при бронировании, количество выбранных мест должно соответствовать количеству туристов');
      return Promise.reject();
    }

    return super.submit()
      .then(() => api.tour.client
        .book({data: this.data})
        .catch(() => Promise.reject('Ошибка при бронировании')))
      .catch((err) => {
        core.notify.error(err);
        return Promise.reject();
      })
      .finally(() => {
        this.loading = false;
      });
  }

  getById(id) {
    this.loading = true;
    this.id = id;
    return api.tour.client
      .get({id})
      .then((data) => {
        this.info.set(data);
        this.price.set(data);
        this.program.set(data);
        this.term.set(data);
        this.hotel.set(data);
        this.additionalService.set(data);
        this.dates.date = this.info.date.to;
        this.tariffs.set(data);
        this.seat.set(data);
        return this.tourist.set(data);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  setTariff(data) {
    this.id = data.tour.value;
    this.price.price = data.price;
    this.info.tourist.adult = this.tariffs.adult;
    this.info.tourist.child = this.tariffs.child;
    this.tourist.set({
      adults: this.tariffs.adult,
      children: this.tariffs.child,
    });
  }
}
